module.exports = __webpack_public_path__ + "static/media/ste_wor_net_bea_bag.ad0eab69.png";